import React from 'react';
import { Route, Routes } from 'react-router-dom';
import PFS404Page from '../PFS404Page/PFS404Page';
import PFSPartnersIndex from '../PFSPartnersIndex/PFSPartnersIndex';
import PFSAscend from '../PFSAscend/PFSAscend';
import PFSAgencyTransform from '../PFSAgencyTransform/PFSAgencyTransform';
import ExternalRedirect from '../ExternalRedirect/ExternalRedirect';
import PFSPremierPartner from '../PFSPremierPartner/PFSPremierPartner';
import PFSCombinedAgents from '../PFSCombinedAgents/PFSCombinedAgents';
import PFSMarketRetrievers from '../PFSMarketRetrievers/PFSMarketRetrievers';
import PFSVIAA from '../PFSVIAA/PFSVIAA';
import PFSPIIB from '../PFSPIIB/PFSPIIB';

const PFSPartnersRoutes = () => (
  <Routes>
    <Route path="/" element={<PFSPartnersIndex />} />
    <Route path="/ascend" element={<PFSAscend />} />
    <Route path="/agency-transform" element={<PFSAgencyTransform />} />
    <Route path="/archway" element={<ExternalRedirect title="PFS Global" url="/" />} />
    <Route path="/premier" element={<PFSPremierPartner />} />
    <Route path="/combined-agents-of-america" element={<PFSCombinedAgents />} />
    <Route path="/market-retrievers" element={<PFSMarketRetrievers />} />
    <Route path="/viaa" element={<PFSVIAA />} />
    <Route path="/piib" element={<PFSPIIB />} />
    <Route path="*" element={<PFS404Page />} />
  </Routes>
);

PFSPartnersRoutes.propTypes = {};

export default PFSPartnersRoutes;
